import { render } from "./EmployeePayments.vue?vue&type=template&id=193d84c2"
import script from "./EmployeePayments.vue?vue&type=script&lang=js"
export * from "./EmployeePayments.vue?vue&type=script&lang=js"

import "./EmployeePayments.vue?vue&type=style&index=0&id=193d84c2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__